import { render, staticRenderFns } from "./caseClassify.vue?vue&type=template&id=68ad3c50&scoped=true&"
import script from "./caseClassify.vue?vue&type=script&lang=js&"
export * from "./caseClassify.vue?vue&type=script&lang=js&"
import style0 from "./caseClassify.vue?vue&type=style&index=0&id=68ad3c50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad3c50",
  null
  
)

export default component.exports